import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/usersAffiliation';
import { actions } from './affiliationUsersList.slice';
import {
  AddMemberAction,
  EditMemberAction,
  AffiliationUsersListFetchAction,
} from './affiliationUsersList.types';
import { Resp, dispatch } from '../helpers';
import { addTeamMember, editTeamMember } from '@api/teamMembers';
import _ from 'lodash';
import { runToast } from '../tools';

export function* fetchAffiliationUsersListWorker(
  action: AffiliationUsersListFetchAction
) {
  try {
    const response: Resp<typeof api.fetchUsersAffiliationList> = yield call(
      api.fetchUsersAffiliationList,
      action.payload.clinicalTrialId,
      action.payload.role,
      action.payload.filters
    );
    yield dispatch(actions.fetchAffiliationUsersListSuccess(response.data));
  } catch (error) {
    yield dispatch(actions.fetchAffiliationUsersListFailure(error as Error));
  }
}

export function* addMemberWorker(action: AddMemberAction) {
  try {
    const response: Resp<typeof addTeamMember> = yield call(
      addTeamMember,
      action.payload.clinicalTrialId,
      _.omit(action.payload, 'clinicalTrialId')
    );
    if (response.status !== 200) {
      throw new Error('bad request');
    }
    runToast('success', 'Member added successfully');
    yield dispatch(actions.addMemberSuccess(null));
  } catch (error) {
    yield call(runToast, 'error', 'Error during adding member');
    yield dispatch(actions.addMemberFailure(null));
  }
}

export function* editMemberWorker(action: EditMemberAction) {
  try {
    const response: Resp<typeof editTeamMember> = yield call(
      editTeamMember,
      action.payload.clinicalTrialId,
      _.omit(action.payload, 'clinicalTrialId')
    );
    if (response.status !== 200) {
      throw new Error('bad request');
    }
    runToast('success', 'Member edited successfully');
    yield dispatch(actions.editMemberSuccess(null));
  } catch (error) {
    yield call(runToast, 'error', 'Error during editing member');
    yield dispatch(actions.editMemberFailure(null));
  }
}

export function* affiliationUsersListSaga() {
  yield takeLatest(
    actions.fetchAffiliationUsersList.type,
    fetchAffiliationUsersListWorker
  );
  yield takeLatest(actions.addMemberRequest.type, addMemberWorker);
  yield takeLatest(actions.editMemberRequest.type, editMemberWorker);
}
